/** Pipeline + final statuses stored on `applications.status`. */
export type ApplicationStatus =
  | "applied"
  | "reviewed"
  | "shortlisted"
  | "rejected"
  | "withdrawn"

export const APPLICATION_STATUS_LABEL: Record<ApplicationStatus, string> = {
  applied: "Applied",
  reviewed: "Reviewed",
  shortlisted: "Shortlisted",
  rejected: "Not selected",
  withdrawn: "Withdrawn",
}

export function applicationStatusLabel(status: string) {
  return (
    APPLICATION_STATUS_LABEL[status as ApplicationStatus] ??
    status.charAt(0).toUpperCase() + status.slice(1)
  )
}

export function isFinalApplicationStatus(status: string) {
  return (
    status === "shortlisted" || status === "rejected" || status === "withdrawn"
  )
}
